/**
 * Icon set for NowPlayingHeader pills + tag pills downstream.
 *
 * Hand-rolled inline SVGs at 14×14 viewBox. `currentColor` everywhere so the
 * pill color cascades. Add new icons here, keep them visually consistent
 * (1.5px stroke / monoline feel).
 */
import { FC } from "react";

interface IconProps {
  size?: number | string;
  className?: string;
}

const baseProps = (size: number | string, className?: string) => ({
  width: size,
  height: size,
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  className,
});

/** Up-right trending arrow with an underline. */
export const TrendingIcon: FC<IconProps> = ({ size = 14, className }) => (
  <svg {...baseProps(size, className)}>
    <path d="M2 11.5 6 7.5l2.5 2.5L13 5" />
    <path d="M9.5 5h3.5v3.5" />
  </svg>
);

/** Flame / aces icon. */
export const FireIcon: FC<IconProps> = ({ size = 14, className }) => (
  <svg {...baseProps(size, className)}>
    <path d="M8 1.5c1 2 3 3 3 6a3 3 0 0 1-6 0c0-1.2.5-2 1.2-2.6C6.6 5 6.4 4 8 1.5Z" />
    <path d="M5 9.5a3 3 0 0 0 6 0" />
  </svg>
);

/** Shield — 1vX clutch. */
export const ShieldIcon: FC<IconProps> = ({ size = 14, className }) => (
  <svg {...baseProps(size, className)}>
    <path d="M8 1.5 2.5 3.5v4c0 3 2.5 5.5 5.5 7 3-1.5 5.5-4 5.5-7v-4L8 1.5Z" />
  </svg>
);

/** Crosshair / target — 4K / 3K multi-kill pills. */
export const CrosshairIcon: FC<IconProps> = ({ size = 14, className }) => (
  <svg {...baseProps(size, className)}>
    <circle cx="8" cy="8" r="5" />
    <path d="M8 1v3M8 12v3M1 8h3M12 8h3" />
    <circle cx="8" cy="8" r="1" fill="currentColor" stroke="none" />
  </svg>
);
